import React from "react";
import { Download } from "lucide-react";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  const pdfUrl = `${process.env.PUBLIC_URL || ""}/Olmi-Srl-Company-Profile-${lang.toUpperCase()}.pdf`;
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-4xl md:text-6xl font-semibold tracking-tight text-white">OLMI</span>
              <span className="font-accent text-sm tracking-[0.3em] text-[#D4AF37] uppercase">Srl</span>
            </div>
            <p className="mt-4 text-zinc-500 max-w-xs">{t.footer.tagline}</p>
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="download-profile-btn"
              className="btn-fill group mt-7 inline-flex items-center gap-3 border border-[#D4AF37] px-6 py-3 font-accent text-xs uppercase tracking-widest text-[#D4AF37] hover:text-black"
            >
              <Download size={16} />
              {t.footer.download}
            </a>
          </div>
          <div className="text-left md:text-right space-y-2">
            <a href="mailto:info@olmisrl.it" className="block text-zinc-300 hover:text-[#D4AF37] transition-colors">info@olmisrl.it</a>
            <a href="tel:+393462179997" className="block text-zinc-300 hover:text-[#D4AF37] transition-colors">346 2179997 — 035 903812</a>
            <span className="block text-zinc-400">{t.contact.address}</span>
            <span className="block text-zinc-600 text-sm">www.olmisrl.it</span>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-zinc-600">
          <span>© {year} Olmi Srl. {t.footer.rights}</span>
          <span className="font-accent uppercase tracking-widest">Made in Italy — 1970</span>
        </div>
      </div>
    </footer>
  );
}
